// extracted by mini-css-extract-plugin
export default {"repImage":"styles_repImage__2ecjp","ionIcon":"styles_ionIcon__ucz2z"};